// extracted by mini-css-extract-plugin
export default {"heading":"DefaultBid_heading__NhrkD","wrapper":"DefaultBid_wrapper__B4o2l","suggestionText":"DefaultBid_suggestionText__3aal5","pandaImg":"DefaultBid_pandaImg__zy-st"};